import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Loading from "../reusableComponents/loadingScreens";
import {
  clearProjectDetails,
  getProjectDetails,
} from "../../API/store/actions/projects/projects";
import { resolver } from "../../API/middlewares/resolveRequests";
import ProjectDetails from "./projectDetails";
import { ScrollToTop } from "../../algorithms";

const ProjectDetailsIndex = () => {
  const [procAdded, setProcAdded] = useState(false);

  const { id } = useParams();
  const [projectDetails, setProjectDetails] = useState(null);
  const userToken = useSelector((state) => state.login.userToken);
  const reload = useSelector((state) => state.reload.reload);

  useEffect(() => {
    if (projectDetails) setProjectDetails(null);
    resolver(getProjectDetails, setProjectDetails, parseInt(id), userToken);
    ScrollToTop();
    return () => {
      clearProjectDetails();
    };
  }, [procAdded, reload]);
  if (projectDetails?.data)
    return (
      <>
        <div className="d-flex flex-column align-items-center align-items-sm-start col-xl-8 col">
          <ProjectDetails
            ProjectDetails={projectDetails}
            id={id}
            setProcAdded={setProcAdded}
            procAdded={procAdded}
          />
        </div>
      </>
    );
  else
    return (
      <div>
        <Loading />
      </div>
    );
};

export default ProjectDetailsIndex;
